function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_iii_18_14837)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint0_radial_18_14837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint1_radial_18_14837)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint2_radial_18_14837)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint3_radial_18_14837)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint4_radial_18_14837)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6046 3.74448L20.8077 8.36425C21.1488 9.05025 21.771 9.5326 22.4934 9.63978L27.4208 10.3365C29.9595 10.7117 30.9171 13.4375 28.9483 15.4219L25.4952 18.9844C24.9333 19.5417 24.6724 20.3671 24.8128 21.171L25.5889 26.2344C26.0304 28.8605 23.8186 30.7236 21.5809 29.5231L17.0454 27.1114C16.4133 26.7791 15.6708 26.7791 15.0386 27.1114L10.5031 29.5231C8.26548 30.7128 5.91705 28.9062 6.5733 26.1719L7.33893 21.2188C7.47941 20.4148 7.21852 19.5895 6.6566 19.0322L3.13576 15.3438C1.15142 13.3828 2.12453 10.7117 4.66319 10.3365L9.40939 9.63978C10.1319 9.5326 10.9609 9.06097 11.2921 8.36425L13.5397 3.74448C14.6836 1.41851 17.4707 1.41851 18.6046 3.74448Z",
  fill: "url(#paint5_radial_18_14837)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_iii_18_14837",
  x: 0.827209,
  y: 1.5,
  width: 30.6728,
  height: 29.6455,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.772549 0 0 0 0 0.494118 0 0 0 0 0.282353 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_14837"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -1.25,
  dy: 1.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.952941 0 0 0 0 0.286275 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_14837",
  result: "effect2_innerShadow_18_14837"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1.5,
  dy: -0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.698039 0 0 0 0 0.537255 0 0 0 0 0.192157 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_14837",
  result: "effect3_innerShadow_18_14837"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.5421 8.96877) rotate(132.939) scale(19.9803 19.7731)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAC632"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7C632"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0386 15.9478) rotate(90) scale(13.9478 13.9614)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DDBA38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DDBA38",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.06005 10.0815) rotate(74.0546) scale(2.26515 7.5594)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DDBA38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DDBA38",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.07721 11.5205) rotate(16.0828) scale(3.93102 3.93486)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B5953A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B5953A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.88802 30.8113) rotate(-58.4957) scale(2.82823 2.83099)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C47E42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C47E42",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_14837",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(31.0569 11.6761) rotate(150.751) scale(2.2288 2.93061)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF246"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF246",
  stopOpacity: 0
})));

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.779fe42b.svg";
export { ForwardRef as ReactComponent };